import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  margin-top: 32px;
  flex-direction: column;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    flex-direction: row;
    gap: 108px;
    margin-top: 48px;
  }
`;
export const DescriptionWrapper = styled.div``;

export const GifWrapper = styled.video`
  width: 100%;
  height: 385px;
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 540px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 48px;
  }
`;

export const DescriptionTitle = styled.h6`
  font-size: ${16 / 16}rem;
  font-family: "Inter", sans-serif;
  color: ${(props) => props.theme.palette.greyscale.grey800};
  font-weight: 600;
  margin-top: 32px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${24 / 16}rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 48px;
  }
`;

export const DescriptionParagraph = styled.p`
  margin-top: 8px;
  font-size: ${14 / 16}rem;
  color: ${(props) => props.theme.palette.greyscale.grey600};
  opacity: 0.7;
  font-family: "Inter", sans-serif;
  font-weight: 500;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${16 / 16}rem;
  }
`;

export const BannersWrapper = styled.div`
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 24px;
  column-gap: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    column-gap: 24px;
  }
`;

export const Banner = styled.div`
  padding: 16px 8px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid hsl(245, 60%, 96%);
  border-radius: 8px;

  h6 {
    margin-top: 24px;
    font-weight: 600;
    font-size: ${14 / 16}rem;
    color: ${(props) => props.theme.palette.greyscale.grey800};
    font-family: "Inter", sans-serif;
  }

  p {
    margin-top: 8px;
    font-weight: 400;
    font-size: ${12 / 16}rem;
    line-height: ${20 / 16}rem;
    color: ${(props) => props.theme.palette.greyscale.grey600};
    font-family: "Inter", sans-serif;
    text-align: center;
  }

  img {
    width: 64px;
    height: 65px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-items: flex-start;
    padding: 0;
    border: none;

    h6 {
      font-size: ${16 / 16}rem;
    }
    p {
      margin-top: 16px;
      font-size: ${14 / 16}rem;
      text-align: left;
    }
  }
`;
